<div class="product-details-container">
  <div class="product-image-section">
    <div class="image-container">
      <img [alt]="service?.Title"
           [src]="formatImage('', service?.Images[0])"
           class="product-image"
           loading="lazy">
    </div>
  </div>
  <div class="product-info-section">
    <div class="product-header">
      <h1 class="product-title">{{ service?.Title }}</h1>
      <div class="rating-container">
        <div class="rating">
          <span class="rating-value">{{ service?.Rate || 0 | number:'1.1-1' }}</span>
          <img alt="rating"
               class="star-icon"
               src="/icons/star.svg">
        </div>
      </div>
    </div>
    <div class="product-description">
      <p [innerHTML]="domSanitizer.bypassSecurityTrustHtml(service?.Description ?? '')"></p>
    </div>
    <div class="price-section">
      <div class="price-container">
        @if (service?.ServicePrices[0]?.DiscountPercentage) {
          <div class="discount-badge">
            %{{ service?.ServicePrices[0].DiscountPercentage }}
          </div>
        }
        <div class="price-info">
          @if (hasMandatoryServicePriceAdditives(service)) {
            <div class="d-flex align-items-center">
              <span class="currency">از</span>
              <p class="mx-2 current-price">
                {{ StringUtil.numberAsCurrency(getCheapestServicePriceAdditives(service)) }}
              </p>
              <span class="currency">ریال</span>
            </div>
          } @else {
            @if (service?.ServicePrices[0]?.NewPrice) {
              <div class="current-price">
                {{ StringUtil.numberAsCurrency(service?.ServicePrices[0]?.NewPrice) }} ریال
              </div>
            } @else {
              <div class="current-price">
                {{ StringUtil.numberAsCurrency(service?.ServicePrices[0]?.Price) }} ریال
              </div>
            }
            @if (service?.ServicePrices[0]?.NewPrice && service?.ServicePrices[0]?.Price !== service?.ServicePrices[0]?.NewPrice) {
              <div class="original-price">
                {{ StringUtil.numberAsCurrency(service?.ServicePrices[0]?.Price) }} ریال
              </div>
            }
          }
        </div>
      </div>
      @if (service?.ServicePrices?.[0]?.ServicePriceId) {
        @if (getRemainedCountLabel(service, service.ServicePrices[0].ServicePriceId) !== '0') {
          @if (service.IsOutOfServiceTime) {
            <span class="out-of-stock">خارج از زمان سرویس دهی</span>
          } @else {
            @if (getProductAttributePriceCount(service.ServicePrices[0].ServicePriceId) === 0) {
              <div class="d-flex align-items-center justify-content-between gap-2">
                <img (click)="onProductOrderClicked(1, $event)"
                     class="cursor-pointer"
                     src="/icons/add-square.svg">
              </div>
            } @else {
              <div class="d-flex align-items-center justify-content-between gap-2">
                <img (click)="onProductOrderClicked(-1, $event)"
                     class="cursor-pointer"
                     src="/icons/bag.svg">
                <span class="fz-14">{{ getProductAttributePriceCount(service.ServicePrices[0].ServicePriceId) }}</span>
                <img (click)="onProductOrderClicked(1, $event)"
                     class="cursor-pointer"
                     src="/icons/add-square.svg">
              </div>
            }
          }
        } @else {
          <span>اتمام موجودی</span>
        }
      }
    </div>
  </div>
  <div class="section-divider"></div>
  <div class="reviews-section">
    <h2 class="section-title">نظرات کاربران</h2>
    @if (comments.length > 0) {
      @for (comment of comments ?? []; track $index) {
        @if (comment?.Comment) {
          <div class="review-card">
            <div class="review-header">
              <div class="user-info">
                <p class="user-name">{{ comment?.User?.FirstName + ' ' + comment?.User?.LastName }}</p>
                <p class="dot"></p>
                <p class="review-date">{{ comment?.ModifyDate | time: 'dddd DD MMMM YYYY' }}</p>
              </div>
              <div class="review-rating">
                <span class="rating-value">{{ service?.User?.Rating || 0 | number:'1.1-1' }}</span>
                <img alt="rating"
                     src="/icons/star.svg">
              </div>
            </div>
            <div class="review-content">
              <p class="review-text">{{ comment?.Comment }}</p>
              <div class="review-tags">
                @for (factorOrder of comment?.Factor.FactorOrders ?? []; track $index) {
                  <span class="tag">{{ factorOrder?.Order?.ServicePrice?.Service?.Title }}</span>
                }
              </div>

              @if (comment?.Replies && comment.Replies.length > 0) {
                <div class="replies-section">
                  @for (reply of comment.Replies; track $index) {
                    <div class="reply-card">
                      <div class="reply-header">
                        <div class="reply-user-info">
                          <img (error)="onImageError($event)"
                               [src]="formatImage('x', Config.branch.Icon)"
                               alt="رستوران"
                               class="restaurant-icon">
                          <span class="reply-user">{{ reply.User }}</span>
                        </div>
                      </div>
                      <div class="reply-content">
                        <p class="reply-text">{{ reply.Message }}</p>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      }
    } @else {
      <div class="review-card d-flex">
        <span class="rating-value">هنوز نظری ثبت نشده</span>
      </div>
    }
  </div>
</div>
